import React, { useState } from 'react'
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandLess, ExpandMore, IndeterminateCheckBox } from '@material-ui/icons'
import Checkbox from '../Checkbox/CheckboxWrapper'

const useStyles = makeStyles(() => ({
  checkbox: {
    width: '100%',
    maxWidth: 360,
  },
  nestedCheckbox: {
    '& .MuiListItem-gutters': {
      paddingLeft: '3rem',
    },
  },
}))

const CheckBoxListWrapper = props => {
  const checkboxListConfig = {
    color: 'secondary',
    ...props,
  }

  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const {
    checked,
    checkboxList,
    toggleCheckbox,
    toggleCollapseCheckbox,
    collapseCheckbox,
    collapseItem,
    nestedCheckboxList,
    collapsedCheckedCount,
    color,
  } = checkboxListConfig

  return (
    <List className={classes.checkbox}>
      {checkboxList.map((checkbox, index) => {
        const labelId = `checkbox-list-label-${checkbox}`
        const checkboxListLength = checkboxList.length

        return collapseCheckbox && collapseItem === checkbox ? (
          <React.Fragment>
            <ListItem
              key={checkbox}
              button
              onClick={event => toggleCollapseCheckbox(event, index)}
              dense
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={collapsedCheckedCount === nestedCheckboxList.length}
                  color={color}
                  tabIndex={-1}
                  indeterminate={
                    collapsedCheckedCount > 0 && collapsedCheckedCount < nestedCheckboxList.length
                  }
                  indeterminateIcon={<IndeterminateCheckBox style={{ color: '#6cc04a' }} />}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': { labelId },
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={checkbox} />
              <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="collapse" onClick={() => setOpen(!open)}>
                  {open ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" className={classes.nestedCheckbox}>
                {nestedCheckboxList.map((nestedCheckbox, index) => (
                  <ListItem
                    key={nestedCheckbox}
                    button
                    onClick={event => toggleCheckbox(event, checkboxListLength + index)}
                    dense
                  >
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked[checkboxListLength + index]}
                        color={color}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': { labelId } }}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={nestedCheckbox} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ) : (
          <ListItem key={checkbox} button onClick={event => toggleCheckbox(event, index)} dense>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={checked[index]}
                color={color}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': { labelId } }}
              />
            </ListItemIcon>
            <ListItemText id={labelId} primary={checkbox} />
          </ListItem>
        )
      })}
    </List>
  )
}

export default CheckBoxListWrapper
